
<mat-dialog-content>
  <div class="container">
          
        <div class="content">
          <mat-tab-group animationDuration="0ms" backgroundColor="primary" dynamicHeight>

              <mat-tab label="Common">

                <button mat-button (click)="financialYear('2020-07-01T00:00:00Z', '2021-06-30T00:00:00Z')">2020-2021 Financial Year</button>
                <button mat-button (click)="financialYear('2021-07-01T00:00:00Z', '2022-06-30T00:00:00Z')">2021-2022 Financial Year</button>
                <button mat-button (click)="financialYear('2022-07-01T00:00:00Z', '2023-06-30T00:00:00Z')">2022-2023 Financial Year</button>
                <br>

                <!-- <button mat-button (click)="financialYear('2021-01-01T00:00:00Z', '2021-03-31T00:00:00Z')">1st Quater</button>
                <button mat-button (click)="financialYear('2021-06-01T00:00:00Z', '2021-06-30T00:00:00Z')">2nd Quater</button>
                <button mat-button (click)="financialYear('2021-07-01T00:00:00Z', '2021-09-30T00:00:00Z')">3rd Quater</button>
                <button mat-button (click)="financialYear('2021-07-01T00:00:00Z', '2022-03-31T00:00:00Z')">4th Quater</button> -->

                <button mat-button (click)="financialYear('2022-01-01T00:00:00Z', '2022-03-31T00:00:00Z')">Custom Quater for BAS Statement</button>

                <br>

                <button mat-button (click)="thisMonth()">This Month</button>
                <button mat-button (click)="thisWeek()">This Week</button>
                <button mat-button (click)="lastWeek()">Last Week</button>
                
                <br>

                <button mat-button (click)="financialYear('2021-09-05T00:00:00Z', '2021-09-30T00:00:00Z')">Custom Week</button>

              </mat-tab>

              <mat-tab label="Finacial Year">
                Test
              </mat-tab>
          
              <mat-tab label="Between">
                TEst
              </mat-tab>
            </mat-tab-group>
          </div>


          <div class="footer confirm-evidence">
            <mat-dialog-actions align="end">
              <button mat-raised-button mat-dialog-close>Cancel</button>
              <button mat-raised-button color="warn">Apply</button>
            </mat-dialog-actions>
          </div>
  </div>
</mat-dialog-content>

